import * as t from 'io-ts';
import { Authentication } from 'acscp/api/requests/core/baseRequest';
import { BaseDeleteRequest } from './core/baseDeleteRequest';

export class CancelFlightRequestRequest extends BaseDeleteRequest<undefined> {
    constructor(bookingId: string) {
        super(`flight-requests/${bookingId}`, {}, null, t.undefined, Authentication.Login);
    }
}
